import { useMemo } from 'react';
import { Col } from 'reactstrap';

import moment from 'moment';

import { getInfo, keyOf } from '@Components/Grid/components/Table/formatters';
import { useGrid } from '@Components/Grid/context';
import DetailsModal, { DetailsModalItem } from 'components/modals/DetailsModal';

export default function DetailsEntityFormatter({ info }) {
  const { row } = getInfo(info)

  const id = keyOf(info, 'details')

  return <DetailsModal id={id} title='IP Blocking Details'>
    <DetailsModalItems data={row} />
  </DetailsModal>
}

function DetailsModalItems({ data }) {
  const { store: { loading, collection: { useLoad, item } } } = useGrid()
  const { id, ip, reason, siteId } = data

  const params = useMemo(() => ({ ip, reason, siteId }), [ip, reason, siteId])
  useLoad(id, params)

  if (!item || loading) {
    return <Col sm="12">Loading...</Col>
  }

  return <>
    <DetailsModalItem label='IP Address' value={ip} />
    <DetailsModalItem label='Site ID' value={siteId} />
    <DetailsModalItem label='Blocking Reason' value={reason} />
    <DetailsModalItem label='Release in' value={ttlFormatter(item.ttl)} />
    <DetailsModalItem label='Email MD5' value={emailFormatter(item.emails)} />
  </>
}

const ttlFormatter = ttl => {
  const ttlFormatted = moment.duration(ttl, "seconds").humanize()
  return `${ttlFormatted.humanize()} (${ttl} seconds)`
}

const emailFormatter = emails => {
  emails = emails || "{}"
  return <pre>{JSON.stringify(emails, null, 2)}</pre>
}
